module.exports = __webpack_public_path__ + "img/4ec0104.jpeg";